module.exports = __webpack_public_path__ + "static/media/background_image.2ef5a133.png";